export default class UnderlayHelper {
  // Note: this class is meant to be used as a helper,
  // instantiated and called from other classes,
  // so we don't currently need to mount it to the component
  constructor(options = { transparent: false, overNav: false }) {
    this.dom = {
      $component: document.querySelector('[data-component="UnderlayHelper"]'),
    };

    this.state = {
      options,
      open: false,
      animating: false,
      animationDuration: 300,
      activeClass: options.transparent ? 'UnderlayHelper--active-transparent' : 'UnderlayHelper--active',
      zIndexClass: options.overNav ? 'UnderlayHelper--over-nav' : 'UnderlayHelper--under-nav',
    };

    this.mount();
  }

  mount() {
    this.setState();
  }

  setState() {
    const { dom, state } = this;

    state.open = dom.$component.classList.contains(state.activeClass);
  }

  addClickListener(callback) {
    const { dom } = this;
    dom.$component.addEventListener('click', callback);
  }

  open() {
    const { dom, state } = this;
    console.log('UnderlayHelper : open', this);

    state.animating = true;

    setTimeout(() => {
      dom.$component.classList.add(state.activeClass, state.zIndexClass);
    }, 25);

    setTimeout(() => {
      state.open = true;
      state.animating = false;
    }, state.animationDuration);
  }

  close() {
    const { dom, state } = this;
    console.log('UnderlayHelper : close', this);

    state.animating = true;

    setTimeout(() => {
      dom.$component.classList.remove(state.activeClass, state.zIndexClass);
    }, 25);

    setTimeout(() => {
      state.open = false;
      state.animating = false;
    }, state.animationDuration);
  }
}
